export default __webpack_public_path__ + "static/media/thumbnail_blog_15.0d09d889.png";